import React from 'react'

import { Box, Typography, useTheme } from '@mui/material'
import {
  ApplicationWaitingProps,
  OffToRacesScreen,
  OffToRacesScreenCreditOffer
} from './types'
import { PacelineLoaderIcon } from '../../Icons/PacelineLoaderIcon'
import {
  sendTrackingEvent,
  toScreenEvent
} from '../../../services/amplitude.service'

export const ApplicationWaitingComponent: React.FC<ApplicationWaitingProps> = ({
  subtitleText
}) => {
  const theme = useTheme()

  const event = subtitleText ? OffToRacesScreenCreditOffer : OffToRacesScreen
  sendTrackingEvent(toScreenEvent({ ...event }))

  return (
    <>
      <Typography variant="h4" component="div" align="center" gutterBottom>
        Off to the Races!
      </Typography>

      <Typography
        variant="subtitle2"
        component="div"
        align="center"
        sx={{ mb: 4 }}
      >
        {!subtitleText ? 'Your application is processing.' : subtitleText}
      </Typography>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <PacelineLoaderIcon />
      </div>

      <Box
        sx={{
          p: 2,
          bgcolor: theme.palette.secondary.light,
          borderRadius: 5,
          mt: 5,
          maxWidth: 350
        }}
      >
        <Typography>
          This shouldn’t take long. But if you need to leave, you can come back
          at any time to check on the status of your application.
        </Typography>
      </Box>
    </>
  )
}
